import React,{useEffect,useState} from 'react';
export default function VisitorCount(){
  const [count,setCount]=useState(null);
  useEffect(()=>{
    const counted=sessionStorage.getItem('technoration-visit-counted');
    fetch('/api/visits',{method:counted?'GET':'POST'}).then(response=>response.ok?response.json():null).then(data=>{
      if(Number.isSafeInteger(data?.count)){setCount(data.count);if(!counted)sessionStorage.setItem('technoration-visit-counted','1')}
    }).catch(()=>{});
  },[]);
  return count===null?null:<p className="visitor-count">Site visits: {count.toLocaleString()}</p>;
}
